import { useState } from "react";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Menu, X, Facebook, Instagram, Twitter, Home, Phone, Info, PhoneCallIcon } from "lucide-react";
import { FaMapMarkerAlt } from "react-icons/fa";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  // Navigation links with readable names and Lucide icons
  const navLinks = [
    { name: "Home", icon: <Home size={16} className="mr-2" />, href: "/" },
    { name: "About", icon: <Info size={16} className="mr-2" />, href: "/about" },
    { name: "Contact", icon: <Phone size={16} className="mr-2" />, href: "/contact" }
  ];

  // Social icons
  const socials = [

    { icon: <Instagram size={16} />, label: "IG", href: "https://www.instagram.com/authorsweta2025" },

  ];

  return (
    <div className="w-full bg-[#FFFBF4] fixed top-0 left-0 z-50">
      {/* Top Bar */}
      <div className="bg-[#11120D] text-[#FFFBF4] text-xs tracking-widest px-6 py-2 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <a
            href="mailto:singhsweta112@gmail.com"
            className="flex items-center gap-1 hover:text-[#FACC15] transition"
          >
            <PhoneCallIcon size={14} className="inline-block mr-1" />
            singhsweta112@gmail.com
          </a>
          <span className="mx-2 text-[#FACC15]">|</span>
          <span className="hidden sm:inline flex items-center gap-1">
            <FaMapMarkerAlt className="inline-block mr-1"  size={14} />
            Delhi, India
          </span>
        </div>
        <div className="flex gap-4">
          {socials.map(s => (
            <a
              key={s.label}
              href={s.href}
              className="hover:text-[#FACC15] transition flex items-center"
              aria-label={s.label}
            >
              {s.icon}
              {/* Show handle for Instagram */}
              {s.label === "IG" && (
                <span className="ml-1 text-xs font-mono text-[#FFFBF4]/80 hidden sm:inline">@authorsweta2025</span>
              )}
            </a>
          ))}
        </div>
      </div>

      {/* Navbar */}
      <nav className="flex items-center justify-between w-full px-6 lg:px-16 py-5 bg-[#FFFBF4] shadow">
        <div className="flex items-center gap-8 w-full">
          {/* <a href="/" className="font-bold text-xl hover:text-[#EE3333] transition">
            Logo
          </a> */}
          {/* Desktop Nav */}
          <ul className="hidden lg:flex gap-6 text-[#11120D] font-medium">
            {navLinks.map(link => (
              <li key={link.name}>
                <a
                  href={link.href}
                  className="flex items-center hover:text-[#EE3333] transition"
                >
                  {link.icon} {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
        {/* Hamburger for mobile */}
        <div className="flex items-center gap-5 lg:hidden">
          <button aria-label="Menu" className="focus:outline-none" onClick={() => setOpen(!open)}>
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-black/40 transition-opacity duration-200 ease-in-out ${open ? "block" : "hidden"}`}
        onClick={() => setOpen(false)}
        aria-hidden={!open}
      />
      <div
        className={`
          fixed top-0 right-0 z-50 h-full w-64 bg-[#FFFBF4] shadow-lg
          transform transition-transform duration-300 ease-in-out
          ${open ? "translate-x-0" : "translate-x-full"} 
          lg:hidden
        `}
        style={{ marginTop: 0 }}
      >
        <div className="flex justify-between items-center px-6 py-4 border-b">
          {/* <span className="font-bold text-xl">Logo</span> */}
          <button aria-label="Close menu" className="focus:outline-none" onClick={() => setOpen(false)}>
            <X size={28} />
          </button>
        </div>
        <ul className="flex flex-col gap-3 px-6 py-6 text-[#11120D] font-medium">
          {navLinks.map(link => (
            <li key={link.name}>
              <a
                href={link.href}
                className="flex items-center hover:text-[#EE3333] transition text-base py-2"
                onClick={() => setOpen(false)}
              >
                {link.icon} {link.name}
              </a>
            </li>
          ))}
        </ul>
        <div className="flex items-center gap-4 px-6 mt-auto mb-6">
          {socials.map(s => (
            <a
              key={s.label}
              href={s.href}
              className="hover:text-[#FACC15] transition flex items-center"
              aria-label={s.label}
            >
              {s.icon}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
